import { ReactComponent as Arrow } from 'assets/icons/chevronBlue.svg'
import { useClearErrorsAddress } from 'feature/addresses/hooks/useClearErrorsAddress'
import { useSetAddressError } from 'feature/addresses/hooks/useSetAddressError'
import {
  selectAddress,
  yandexMap,
} from 'feature/addresses/redux/addressCreateSelector'
import { TSuggest } from 'feature/registration/types'
import { isAddressWithError } from 'helpers/addressErrorBoundary'
import { ChangeEvent, memo, useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useAppSelector, useActions } from 'store/hooks'
import { Button } from 'ui'
import { DadataSelectInput } from 'widget/index'

import style from './AddressPopup.module.scss'
import { useHandlers } from './helpers/useHandlers'

export type AddressPopupProps = {
  setViewMode: (str: string) => void
  changeSuggestHandler?: (e: ChangeEvent<HTMLInputElement>) => void
}
export type TLastPickedAddress = {
  value: string
  geoLat: number | null
  geoLon: number | null
  suggest: TSuggest | null
}

// выбор адреса для мобилки (без карты)
// только input + список который приходит из дадаты
export const AddressPopup = memo(
  ({ setViewMode, changeSuggestHandler }: AddressPopupProps) => {
    const { control } = useFormContext()
    const {
      input: inputAddress,
      isError: isInputError,
      inputSuggest,
      errorMessage: inputErrorMessage,
    } = useAppSelector(selectAddress)

    const { clickMark } = useAppSelector(yandexMap)
    const setAddressError = useSetAddressError()

    const lastPickedAddress: TLastPickedAddress = {
      value: inputAddress,
      geoLat: clickMark.coords ? Number(clickMark.coords[0]) : null,
      geoLon: clickMark.coords ? Number(clickMark.coords[1]) : null,
      suggest: inputSuggest ? inputSuggest : null,
    }

    const { setIsValidAddress } = useActions()

    const clearErrorsAddress = useClearErrorsAddress()

    const {
      selectAddressHandler,
      backHandler,
      setErrorAddress,
      userAddressClick,
    } = useHandlers({
      setViewMode,
      lastPickedAddress,
    })

    // если есть активный адрес установить его в input при монтирование
    useEffect(() => {
      if (!clickMark.coords) return

      const isAddressHasError = isAddressWithError({
        inputAddress,
        inputSuggest,
        setAddressError,
      })
      if (isAddressHasError) return

      setIsValidAddress(true)
    }, [clickMark.coords])

    // при клике вне input
    const onClickAway = () => {
      if (!inputAddress || (inputAddress.length === 0 && !clickMark.coords))
        return
      const isAddressHasError = isAddressWithError({
        inputAddress,
        inputSuggest,
        setAddressError,
      })
      if (isAddressHasError) return
      setIsValidAddress(true)
    }

    return (
      <div className={style.addressBlock}>
        <Button
          variant='text'
          startIcon={<Arrow className='rotate180' />}
          onClick={backHandler}
        >
          Назад
        </Button>
        <div className={style.addressInputWrapper}>
          <Controller
            name='address'
            control={control}
            render={({ field }) => (
              <DadataSelectInput
                onChange={changeSuggestHandler}
                onSelect={selectAddressHandler}
                userAddressClick={userAddressClick}
                onClickAway={onClickAway}
                clearErrorsAddress={clearErrorsAddress}
                setErrorAddress={setErrorAddress}
                isUserAddressHidden={false}
                inputProps={{
                  type: 'text',
                  multiline: true,
                  label: 'Адрес',
                  name: field.name,
                  value: inputAddress,
                  required: true,
                  error: isInputError,
                  helperText: inputErrorMessage,
                }}
              />
            )}
          />
        </div>
      </div>
    )
  },
)
